import { render, staticRenderFns } from "./PatternOptionProductItem.vue?vue&type=template&id=b947e034&scoped=true"
import script from "./PatternOptionProductItem.vue?vue&type=script&lang=js"
export * from "./PatternOptionProductItem.vue?vue&type=script&lang=js"
import style0 from "./PatternOptionProductItem.vue?vue&type=style&index=0&id=b947e034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b947e034",
  null
  
)

export default component.exports